export * from './TS_ComponentTransition.js';
//# sourceMappingURL=index.js.map